import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {isInternalUrl} from "../../utils";

//@ts-ignore
const RoutableNotEditableLink = ({href, ...otherProps}) => {
    if (href && isInternalUrl(href)) {
        return <Link to={href} {...otherProps}/>
    }
    return <a href={href} {...otherProps}/>
};

RoutableNotEditableLink.propTypes = {
    href: PropTypes.string.isRequired,
}

export default RoutableNotEditableLink;

